<hb-modal-dialog id="lookup-copy-confirm-dialog" [heading]="title" [showFooter]="false">
  <div content>
    <p>{{ messageTop }}</p>
    <p *ngIf="messageBottom">
      {{ messageBottom }}
    </p>
  </div>
  <div footerContent>
    <button *ngIf="showCopyWithValues" id="lookup-copy-confirm-dialog-copy-with-values" type="button" class="btn btn-primary" (click)="copyWithValues()">
      {{ copyWithValuesLabel }}
    </button>
    <button id="lookup-copy-confirm-dialog-copy" type="button" *ngIf="showCancel" class="btn btn-primary ml-2" (click)="copy()">
      {{ copyLabel }}
    </button>
    <button id="lookup-copy-confirm-dialog-cancel" type="button" class="btn btn-default pull-right" (click)="cancel()">
      {{ cancelLabel }}
    </button>
  </div>
</hb-modal-dialog>
